module.exports = __webpack_public_path__ + "static/assets/00d81ba391869da17f72d0e3029996e0.gif";